import React, { useContext } from 'react';
import { Modal } from 'react-bootstrap';
import AuthLogo from '../components/AuthLogo';
import RegisterContext from './RegisterContext';
import { UseTranslate } from '../../hooks/Translate';

export const Agreement = () => {
  const { showModal, toggleModal } = useContext(RegisterContext);
  const [translate] = UseTranslate();

  return (
    <Modal
      show={showModal}
      onHide={() => toggleModal(false)}
      animation={false}
      className="terms-and-conditions"
    >
      <Modal.Header>
        <Modal.Title>{translate('cas.registration.rules')}</Modal.Title>
        <button className="link-button" onClick={() => toggleModal(false)}>
          <svg width="15px" height="15px" viewBox="0 0 15 15">
            <path
              d="M9.267,7.5 L14.633,2.134 C14.964335,1.82163264 15.0995917,1.35379766 14.9860594,0.912813883 C14.8725272,0.471830109 14.5281699,0.127472787 14.0871861,0.0139405611 C13.6462023,-0.0995916644 13.1783674,0.0356649952 12.866,0.367 L7.5,5.733 L2.134,0.367 C1.64211013,-0.0967310879 0.870668025,-0.0853677137 0.392650156,0.392650156 C-0.0853677137,0.870668025 -0.0967310879,1.64211013 0.367,2.134 L5.733,7.5 L0.367,12.866 C0.0356649952,13.1783674 -0.0995916644,13.6462023 0.0139405611,14.0871861 C0.127472787,14.5281699 0.471830109,14.8725272 0.912813883,14.9860594 C1.35379766,15.0995917 1.82163264,14.964335 2.134,14.633 L7.5,9.267 L12.866,14.633 C13.1783674,14.964335 13.6462023,15.0995917 14.0871861,14.9860594 C14.5281699,14.8725272 14.8725272,14.5281699 14.9860594,14.0871861 C15.0995917,13.6462023 14.964335,13.1783674 14.633,12.866 L9.267,7.5 Z"
              fill="#6B727B"
            />
          </svg>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center mb-3">
          <AuthLogo />
          <div>
            <iframe title="agreement-rules" width="100%" height="500px" className='frame-container' src="/rules-ge.html"></iframe>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
